import React, { lazy } from 'react';
import HeroSection from '../components/sections/HeroSection';
import StatsSection from '../components/sections/StatsSection';
import TrustSection from '../components/sections/TrustSection';
import ServicesSection from '../components/sections/ServicesSection';
import AssessmentSection from '../components/sections/AssessmentSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import SEO from '../components/ui/SEO';
const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'MedicalBusiness',
  name: 'Medicolegal Psychiatry',
  url: 'https://medicolegal-psychiatry.co.uk/',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hDXV1rDXM1m2ARqkQ9Hg8F/Medico_Favicon.png',
  address: {
    '@type': 'PostalAddress',
    addressRegion: 'Warwickshire',
    addressCountry: 'UK'
  },
  email: 'enquiries@medicolegal-psychiatry.co.uk',
  areaServed: ['England', 'Wales'],
  openingHoursSpecification: [{
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
    opens: '09:00',
    closes: '17:00'
  }, {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: 'Saturday',
    opens: '09:00',
    closes: '13:00'
  }],
  medicalSpecialty: 'Psychiatry',
  founder: {
    '@type': 'Person',
    name: 'Dr Imtiaz Syed',
    jobTitle: 'Independent Psychiatric Expert Witness'
  },
  description: 'Court-ready psychiatric expert witness reports for solicitors and barristers across England and Wales.'
};
export default function Home() {
  return <main className="min-h-screen bg-white" data-id="element-655" data-mp="287ktpqc2lnyi">
      <SEO title="Psychiatric Expert Witness Reports UK | Dr Imtiaz Syed" description="Independent psychiatric expert witness reports for solicitors and barristers: criminal, capacity, immigration, PTSD and more. Request a fee quote." path="/" keywords={['psychiatric expert witness reports', 'independent psychiatric expert witness', 'medico-legal psychiatric reports', 'psychiatric expert witness England and Wales']} imageAlt="Medicolegal Psychiatry, independent psychiatric expert witness reports" schema={homeSchema} data-id="element-656" data-mp="288dri1t1x34i" />
      <HeroSection data-id="element-657" data-mp="1flmfkt99goq9" />
      <StatsSection data-id="element-658" data-mp="1fl4b59cg3479" />
      <TrustSection data-id="element-659" data-mp="1fmp3csbaeb1y" />
      <ServicesSection data-id="element-660" data-mp="1flw6cj24qzx0" />
      <AssessmentSection data-id="element-661" data-mp="1fngyy34vw8s8" />
      <TestimonialsSection data-id="element-662" data-mp="23aov9vkc47i4" />
      <section className="py-8 bg-gray-50 border-t border-gray-200" data-id="element-663" data-mp="23cjen5fyjrk3">
        <div className="container mx-auto px-4" data-id="element-664" data-mp="28ata7h5lgu68">
          <div className="flex items-center justify-center gap-3" data-id="element-665" data-mp="289i6fhc5fmf4">
            <span className="text-slate text-sm" data-id="element-666" data-mp="1tkdrqa4kc0br">Website created by</span>
            <a href="https://bright-pixxel.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 transition-opacity hover:opacity-80" data-id="element-667" data-mp="1yjyp4g4340md">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/spdsZGPouzsb8mdDCE9yxi/Geometric_Logo_of_Bright_Pixxel_Studio.png" alt="Bright Pixxel Studio Web Design" className="h-8 w-auto" loading="lazy" data-id="element-668" data-mp="2r1ks573ndsw8" />
              <span className="font-semibold text-primary" data-id="element-669" data-mp="ocuc1pp8mrps">
                Bright Pixxel Studio
              </span>
            </a>
          </div>
        </div>
      </section>
    </main>;
}